import React, { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Groups = () => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/groups`);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch groups');
                }

                const data = await response.json();

                if (Array.isArray(data)) {
                    setGroups(data);
                } else if (data.message) {
                    setError(data.message); // Handle message responses
                } else {
                    setError('Unexpected response from server');
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGroups();
    }, []);

    if (loading) {
        return (
            <div className='flex w-full flex-col gap-2 p-2'>
                <div className='font-bold my-1 text-[18px] text-center'>Groups</div>
                <div className="flex justify-start items-center w-full my-2">
                    <div className="grid grid-cols-2 md:grid-cols-6 gap-2 w-full">
                        {Array(6).fill(0).map((_, index) => (
                            <div key={index} className="flex flex-col flex-shrink-0 gap-1 bg-white animate-pulse overflow-hidden shadow-lg max-md:h-[250px] md:h-[240px] lg:h-[245px] max-xl:h-[250px] 2xl:h-[260px] w-full p-2 rounded-[12px] cursor-pointer items-center justify-center">
                                <div className="h-[100px] w-[100px] bg-gray-300 rounded-full"></div>
                                <div className="h-[20px] bg-gray-300 rounded-[12px] w-[60%] mt-2"></div>
                                <div className="h-[20px] bg-gray-300 rounded-[12px] w-[80%] mt-2"></div>
                                <div className="h-[40px] bg-gray-300 rounded-[12px] w-full mt-4"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return <div className="text-center text-red-500">{error}</div>;
    }

    return (
        <div className='flex w-full flex-col gap-2 p-2'>
            <div className='font-bold my-1 text-[18px] text-center'>Groups</div>
            <div className="flex justify-start items-center w-full my-2">
                <div className="grid grid-cols-2 md:grid-cols-6 gap-2 w-full">
                    {groups.length > 0 ? (
                        groups.map((group) => (
                            <div key={group.id} className="flex flex-col flex-shrink-0 gap-1 bg-white hover:bg-slate-50 overflow-hidden shadow-lg max-md:h-[250px] md:h-[240px] lg:h-[245px] max-xl:h-[250px] 2xl:h-[260px] w-full p-2 rounded-[12px] cursor-pointer items-center justify-center">
                                <img 
                                    src={group.image_url} 
                                    alt={group.name} 
                                    className="flex object-contain h-[100px] w-[100px] shrink-0 rounded-full" 
                                />
                                <div className="text-center text-cyan-800 hover:text-cyan-700 p-1 rounded-[12px]">{group.platform}</div>
                                <div className="text-center text-cyan-800 p-2 bg-zinc-100 hover:bg-zinc-200 rounded-[12px] w-full">{group.name}</div>
                                <a href={group.join} target="_blank" rel="noopener noreferrer" className="text-center text-green-600 p-4 bg-zinc-100 hover:bg-zinc-200 rounded-[12px] w-full">
                                    Join
                                </a>
                            </div>
                        ))
                    ) : (
                        <p className="text-center w-full text-gray-500">No groups available.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Groups;
